import { ContentBlock } from '../../../../lib/types/aemDataModels';
import { MappedAEMProperties } from '../../../../types';
import PureLink, { PureLinkVariant } from '../../../common/Link/PureLink';
import styles from './CtaBanner.module.scss';

export type CtaBannerProps = {
  contentBlock: ContentBlock;
} & MappedAEMProperties;

const CtaBanner = ({ contentBlock }: CtaBannerProps) => {
  const { heading, content, link, linkLabel } = contentBlock;

  return (
    <article className={styles.container}>
      <div className={styles.banner}>
        {!!heading && <h2 className={styles.heading}>{heading}</h2>}
        {/* eslint-disable-next-line react/no-danger */}
        {!!content && <div className={styles.content} dangerouslySetInnerHTML={{ __html: content }} />}
        {!!link && !!linkLabel && (
          <PureLink href={link} className={styles.link} variant={PureLinkVariant.Button}>
            {linkLabel}
          </PureLink>
        )}
      </div>
    </article>
  );
};

export default CtaBanner;
